import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const reportExportUrl = `${environment.apiUrl}/report/export`;

@Injectable()
export class ReportService {
  constructor(private readonly httpService: HttpService) {}

  downloadReport(reportType: string): Observable<any> {
    const url = `${reportExportUrl}?reportType=${reportType}`;
    return this.httpService.post(url, null);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/report.service.ts